import React, { Component } from "react";
import _ from "lodash";
import { Search } from "semantic-ui-react";
import ReadAxios from "../../axiosComponent/read";
import { LOCAL_STORAGE } from "../../utils/constants";

const initialState = { isLoading: false, results: [], value: "" };

export class SearchDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      results: [],
      value: props.deafultValue || "",
    };
  }

  handleResultSelect = (e, { result }) => {
    this.setState({ value: result.title });
    this.props.setField(this.props.fieldName, result);
  };

  handleSearchChange = (e, { value }) => {

    this.setState({ isLoading: true, value });

    if (LOCAL_STORAGE.customerNo == 1122) {
      if (value.length == 7) { this.props.setField(this.props.fieldName, value); }
    } else {
      this.props.setField(this.props.fieldName, value);
    }

    if (this.props.fieldName === 'data[0].vehicle_number' || this.props.fieldName === 'data[0].driver_id' || this.props.fieldName === 'data[0].driver_name') this.props.setField(this.props.fieldName, value);

    ReadAxios({ baseURL: this.props.masterRoute, url: this.props.masterRouteURL, searchTerm: value })
      .then((res) => {
        setTimeout(
          () => {
            let dataArray = [];
            if (res) {
              dataArray = res?.data?.resultSet.map((item, index) => {
                return {
                  key: item[this.props.masterRouteKey],
                  title: this.props.fieldName === 'vehicle_number' || 'driver_id' || 'driver_name' ? (`${item[this.props.masterRouteName]}`) : (`${item[this.props.masterRouteName]} (${item[this.props.masterRouteKey]})`),
                  raw: { ...item },
                };
              });
            }
            if (this.state.value.length < 1) return this.setState(initialState);
            this.setState({
              isLoading: false,
              results: dataArray,
            });
          },
          300,
          res
        );
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          results: [],
        });
      });
  };

  render() {
    const { isLoading, value, results } = this.state;

    return (
      <>
        <Search
          style={{ margin: "0", padding: "0", width: "100%", borderRadius: "5px" }}
          className="search-input-ui"
          input={{
            icon: this.props.inputIcon || "search",
            iconPosition: "left",
          }}
          loading={isLoading}
          onResultSelect={this.handleResultSelect}
          onSearchChange={_.debounce(this.handleSearchChange, 500, {
            leading: true,
          })}
          results={results}
          value={value}
          {...this.props}
        />
      </>
    );
  }
}

export default SearchDropdown;
